module.exports = __webpack_public_path__ + "static/3-138cdcf23ae3694f34a0ab3ac391857f.jpg";